import styled from 'styled-components';

export const OptionsContainer = styled.div`
  margin: 0px -15px;
  margin-top: 45px;
`;